import Api from '@/assets/js/api.js';

export const QumanoLogService = {
    async create(params) {
        try {
            const response = await Api.post(
                '/theme/v1/qumano/log/create',
                params
            );

            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    },

    async update(params) {
        try {
            const response = await Api.post(
                '/theme/v1/qumano/log/update/',
                params
            );

            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    },

    async get(params) {
        try {
            const response = await Api.get('/theme/v1/qumano/log/get/', {
                params: params
            });

            return response;
        } catch (error) {
            console.error(error);
            return error;
        }
    }
};

export default QumanoLogService;
